var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from 'react';
import { getCoreRowModel, getPaginationRowModel, useReactTable } from '@tanstack/react-table';
import { usePaginationState } from '../../../../infra/ui/table/use-pagination-state';
import { useApiQuery } from '../../../../infra/api';
import { endpoints } from '../../network';
import { columns } from './columns';
export var useBrandsTable = function () {
    var _a, _b;
    var _c = usePaginationState(), pagination = _c.pagination, setPagination = _c.setPagination;
    var _d = useState(''), searchFilter = _d[0], setSearchFilter = _d[1];
    var _e = useState({
        page: pagination.pageIndex + 1,
        perPage: pagination.pageSize,
        search: searchFilter,
        sortBy: 'name:asc',
    }), queryPayload = _e[0], setQueryPayload = _e[1];
    var handleSearchFilterChange = function (newSearchFilter) {
        setSearchFilter(newSearchFilter);
        setPagination({
            pageIndex: 0,
            pageSize: pagination.pageSize,
        });
        setQueryPayload(__assign(__assign({}, queryPayload), { page: 1, search: newSearchFilter }));
    };
    var handlePaginationChange = function (paginationUpdater) {
        var newPagination = paginationUpdater(pagination);
        setPagination(newPagination);
        setQueryPayload(__assign(__assign({}, queryPayload), { page: newPagination.pageIndex + 1 }));
    };
    var brandsQuery = useApiQuery({
        endpoint: endpoints.brandsQuery,
        payload: queryPayload,
    });
    var table = useReactTable({
        data: ((_a = brandsQuery.data) === null || _a === void 0 ? void 0 : _a.list) || [],
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        manualPagination: true,
        onPaginationChange: handlePaginationChange,
        state: {
            pagination: pagination,
        },
        rowCount: ((_b = brandsQuery.data) === null || _b === void 0 ? void 0 : _b.pagination.count) || 0,
    });
    return { table: table, searchFilter: searchFilter, setSearchFilter: handleSearchFilterChange, isLoading: brandsQuery.isLoading };
};
